const API_BASE = 'https://equios-node-795560498566.asia-south1.run.app';

/** Hardcoded payment details — adjust to match your backend. */
export const PAYMENT_PHONE = '+919999999999';
export const PAYMENT_AMOUNT = 1;

/**
 * Set this to your real payment path (from Postman), e.g. `/user/your_payment_route`.
 * Full URL override: set `REACT_APP_PAYMENT_URL` in `.env`.
 */
const PAYMENT_PATH = process.env.REACT_APP_PAYMENT_PATH || '/payment/initiate-payment';

async function parseJsonResponse(res) {
    const text = await res.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        data = { raw: text };
    }
    if (!res.ok) {
        const msg = data?.message || data?.error || res.statusText || 'Request failed';
        const err = new Error(msg);
        err.success = false;
        err.error = msg;
        throw err;
    }
    return { success: true, data };
}

/**
 * POST /user/check_user_session_pass?id={id}
 */
export async function checkUserSessionPass(id) {
    const url = `${API_BASE}/user/check_user_session_pass?id=${encodeURIComponent(id)}`;
    const res = await fetch(url, { method: 'POST' });
    return parseJsonResponse(res);
}

/**
 * Payment request: sends `id` plus hardcoded phone and amount.
 * Override URL with `REACT_APP_PAYMENT_URL` if the path differs.
 */
export async function initiateSessionPassPayment(id, purpose) {
    const url =
        process.env.REACT_APP_PAYMENT_URL || `${API_BASE}${PAYMENT_PATH}`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: Number(id),
            mobile: PAYMENT_PHONE,
            amount: PAYMENT_AMOUNT,
            ...(purpose ? { purpose } : {}),
        }),
    });
    return parseJsonResponse(res);
}
